import type { Database } from "@/types/database.generated";

export type BlogSection = Database["public"]["Enums"]["blog_post_category"];

/** The content sections, in the order the site lists them. */
export const BLOG_SECTIONS = [
  "guides",
  "scenarios",
  "comparisons",
  "articles",
] as const satisfies readonly BlogSection[];

export type BlogSectionHubPathname = `/${BlogSection}`;
export type BlogSectionPostPathname = `/${BlogSection}/[slug]`;

export function sectionHubPathname(
  section: BlogSection,
): BlogSectionHubPathname {
  return `/${section}`;
}

export function sectionPostHref(
  section: BlogSection,
  slug: string,
): { pathname: BlogSectionPostPathname; params: { slug: string } } {
  return { pathname: `/${section}/[slug]`, params: { slug } };
}

/** The section whose post route is `pathname`, or null for any other route. */
export function postPathnameSection(pathname: string): BlogSection | null {
  return (
    BLOG_SECTIONS.find(
      (section) => sectionPostHref(section, "").pathname === pathname,
    ) ?? null
  );
}
